<template>
    <FocusTrap :escape-deactivates="false" initial-focus="#btn-primary-cta" v-model:active="focusTrapActive">
        <div class="tour-card">
            <div class="tour-card-subhead">
                <h3>
                    {{ $t('tourNavRedesign_commonTourStep_headingWhatIsNewHere') }}
                </h3>
                <span>{{ tourStep }}/6</span>
            </div>
            <div class="tour-card-step-content">
                <h3>
                    {{ $t(tourHeadingTranslationKey) }}
                </h3>
                <p>
                    {{ $t(tourDescriptionTranslationKey) }}
                </p>
                <p v-if="tourAdditionalDescription" class="additional">
                    {{ $t(tourAdditionalDescription) }}
                </p>
                <div class="tour-card-step-content-calls-to-action">
                    <KatButton
                        id="btn-primary-cta"
                        class="tour-card-step-content-calls-to-action-btn"
                        variant="primary"
                        :label="
                            $t(
                                this.nextTourStep === tourFinished
                                    ? 'tourNavRedesign_commonTourStep_ctaFinish'
                                    : 'tourNavRedesign_commonTourStep_ctaNextStopOnTour'
                            )
                        "
                        @click="handleNextClicked"
                        data-test-tag="btn-primary-cta"
                    />
                    <KatButton
                        v-if="!(this.nextTourStep === tourFinished)"
                        class="tour-card-step-content-calls-to-action-btn tour-card-step-content-calls-to-action-btn-secondary"
                        variant="secondary"
                        :label="$t('tourNavRedesign_commonTourStep_ctaSkipRestOfTour')"
                        @click="handleSkipClicked"
                        data-test-tag="btn-secondary-cta"
                    />
                </div>
            </div>
        </div>
    </FocusTrap>
</template>

<script>
import KatButton from '../../katal/KatButton.vue';
import { REDESIGN_TOUR_STEPS, useNavRedesignTourStore } from '../../../stores/navRedesignTourStore';
import { mapActions, mapState } from 'pinia';
import { FocusTrap } from 'focus-trap-vue';

export default {
    name: 'TourCard',
    components: { FocusTrap, KatButton },
    data() {
        return {
            focusTrapActive: false,
        };
    },
    mounted() {
        this.focusTrapActive = true;
    },
    computed: {
        ...mapState(useNavRedesignTourStore, ['redesignTourMetricsPublisher']),
        tourFinished() {
            return REDESIGN_TOUR_STEPS.TOUR_FINISHED;
        },
    },
    methods: {
        ...mapActions(useNavRedesignTourStore, ['setTourStep']),
        handleNextClicked() {
            const metric = this.nextTourStep === REDESIGN_TOUR_STEPS.TOUR_FINISHED ? 'finish' : `next-${this.tourStep}`;
            this.redesignTourMetricsPublisher && this.redesignTourMetricsPublisher.publishCounterMonitor(metric, 1);
            this.setTourStep(this.nextTourStep);
        },
        handleSkipClicked() {
            this.redesignTourMetricsPublisher &&
                this.redesignTourMetricsPublisher.publishCounterMonitor(`skip-${this.tourStep}`, 1);
            this.setTourStep(REDESIGN_TOUR_STEPS.TOUR_FINISHED);
        },
    },
    props: {
        tourHeadingTranslationKey: {
            type: String,
            required: true,
        },
        tourDescriptionTranslationKey: {
            type: String,
            required: true,
        },
        tourAdditionalDescription: {
            type: String,
            default: null,
        },
        nextTourStep: {
            type: String,
            default: null,
        },
        tourStep: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.tour-card {
    width: 176px;
    padding: 16px 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: $nordic;
    box-sizing: content-box; // Override AUI style

    &-subhead {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-style: normal;
        line-height: 20px;
        font-size: 14px;

        h3 {
            margin: 0;
            font-size: 14px;
        }

        span {
            color: $tarpon;
        }
    }

    &-step-content {
        display: flex;
        flex-direction: column;

        h3 {
            margin: 0;
            padding: 8px 0 4px;
            font-size: 13px;
            line-height: 18px;
        }

        p {
            margin: 0;
            font-size: 12px;
            line-height: 15px;

            &.additional {
                padding-top: 8px;
            }
        }

        &-calls-to-action {
            padding: 16px 0 0;
            display: flex;
            flex-direction: column;

            &-btn {
                padding: 7px 16px;
                font-size: 12px;

                &-secondary {
                    color: $nordic;
                    border: 1px solid transparent;
                    box-shadow: none;
                    background-color: transparent;
                }
            }
        }
    }
}
</style>
